/* ウィッシュリスト（気になるリスト）— 有料アプリ代替15項目リストの#3。2026-09-17。
   localStorage のみで状態を管理する。アプリ・バックエンド・アカウント連携は不要。
   商品カード（snippets/product-item.liquid）・商品ページ（snippets/product-meta.liquid）の
   ハートボタン（snippets/wishlist-button.liquid）と、/pages/wishlist（sections/wishlist-page.liquid）が
   同じ localStorage キー "radiann_wishlist" を共有する。 */
(function () {
  var STORAGE_KEY = 'radiann_wishlist';

  function readList() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function writeList(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* localStorage が使えない環境（プライベートブラウジング等）では静かに無視する */
    }
  }

  function isSaved(list, id) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === id) return true;
    }
    return false;
  }

  function updateButtonState(btn, active) {
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    var label = btn.querySelector('[data-wishlist-label]');
    if (label) {
      label.textContent = active
        ? btn.getAttribute('data-label-remove')
        : btn.getAttribute('data-label-add');
    }
  }

  function updateCountBadges(count) {
    var badges = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = count;
    }
  }

  function refreshAllButtons() {
    var list = readList();
    var buttons = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      updateButtonState(buttons[i], isSaved(list, buttons[i].getAttribute('data-product-id')));
    }
    updateCountBadges(list.length);
  }

  function toggle(btn) {
    var id = btn.getAttribute('data-product-id');
    var list = readList();
    var idx = -1;
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === id) { idx = i; break; }
    }
    if (idx >= 0) {
      list.splice(idx, 1);
    } else {
      list.push({
        id: id,
        handle: btn.getAttribute('data-product-handle'),
        title: btn.getAttribute('data-product-title'),
        image: btn.getAttribute('data-product-image'),
        url: btn.getAttribute('data-product-url'),
        price: btn.getAttribute('data-product-price')
      });
    }
    writeList(list);
    refreshAllButtons();
    document.dispatchEvent(new CustomEvent('wishlist:changed'));
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    toggle(btn);
  });

  document.addEventListener('wishlist:changed', refreshAllButtons);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAllButtons);
  } else {
    refreshAllButtons();
  }

  window.RadiannWishlist = { readList: readList, writeList: writeList };
})();
